<template>
  <modal name="realive-dialog" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true" @before-close="handleBeforeClose">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeDialog" icon="el-icon-close" type="text"></el-button>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="permissionType == 1">
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">ダウンロードが完了しました！</p><br>
        <p style="font-size: 140%;">これに無料参加するだけで、</p>
        <p style="font-size: 140%;">就活スキルがググーンと上がるイベントを</p>
        <p style="font-size: 140%;">紹介するよ！そのまま内定も出るかも！</p>
        <p style="font-size: 140%;">学歴関係なし誰もOKなイベントだってさ！</p>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/realive_yagish_logo.png" style="width:80%">
          </p>
        </div>
      </div>
      <br />
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">詳細や日程を見る</p>
      </div>
      <br />
      <div class="text-center">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSended1 == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-realive-consult1');">東京開催</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSended1 == true"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br />
      <div class="text-center">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSended2 == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-realive-consult2');">大阪開催</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSended2 == true"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br />
      <div class="text-center">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSended3 == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-realive-consult3');">名古屋開催</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSended3 == true"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br />
      <div class="text-center">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSended4 == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-realive-consult4');">福岡開催</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSended4 == true"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br />
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="permissionType == 2">
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">ダウンロードが完了しました！</p><br>
        <p style="font-size: 140%;"><span style="color:red;">24卒の人へ</span>これから就活大変だと思うけど</p>
        <p style="font-size: 140%;">がんばってね！</p>
        <p style="font-size: 140%;"><span style="color:green;">23卒の人へ</span>最短で内定が貰えるように</p>
        <p style="font-size: 140%;">無料で全力サポートするよ！</p>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/saiplus_yagish_logo.png" style="width:80%">
          </p>
        </div>
      </div>
      <br />
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a>
          <br />
          ㈱アド・トップの<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a
            href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報保護方針</a>
        </p>
      </div>
      <br />
      <br />
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">規約に同意して無料相談を希望する</p>
      </div>
      <br />
      <br />
      <div class="text-center">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSendedAdtop == false"
          style="font-size: 140%;" @click="$eventHub.$emit('send-newgrade-adtop-consult');">23卒の人はこちら</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSendedAdtop == true"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br />
    </div>
    <div class="setting" v-else-if="permissionType == 3">
      <div class="setting-item" style="text-align:center;">
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">＜大手・優良企業に内定したい方必見！＞<br />
            大学受験と同様に就活にも塾があります！<br />
            就活に不安がある方はまずは無料相談をどうぞ
          </p>
        </div>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/24title_image.jpg" style="width:100%">
          </p>
        </div>
        <br />
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/whiteacademy_yagish_logo.jpg" style="width:100%">
          </p>
        </div>
        <br />
        <div class="text-center" v-if="isRandom">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            style="background-color:#0F9934;border-color:#0F9934;"
            onClick="window.open('https://bit.ly/3zNTCEJ', '_blank');"><span>内定率100%の就活塾の<br>無料相談会のお申し込みはこちら</span></button>
        </div>
        <div class="text-center" v-else>
          <button type="button" class="el-button el-button--success"
            :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'"
            style="background-color:#0F9934;border-color:#0F9934;"
            onClick="window.open('https://bit.ly/3NgaPd6', '_blank');"><span>内定率100%の就活塾の<br>無料相談会のお申し込みはこちら</span></button>
        </div>
        <br />
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">エントリーシートなどの書類を改善したい人向け！<br />
            就活には特に不安はないけど、
          </p>
        </div>
        <br />
        <div class="text-center">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            style="background-color:#0F9934;border-color:#0F9934;"
            onClick="window.open('https://bit.ly/3y73R5F', '_blank');"><span>添削/相談だけはお願いしたい人はこちら</span></button>
        </div>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 4">
      <div class="setting-item" style="text-align:center;">
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">日本で就職を考えている留学生限定！<br />
            ヤギッシュで一緒に働いてみない？
          </p>
          <p style="font-size: 100%;">
            合格者にのみ連絡させていただきます。<br />
            予めご了承ください。
          </p>
        </div>
        <br />
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p>
            Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
              target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
              target="_blank">個人情報保護方針</router-link>
          </p>
        </div>
        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSendedYagish == false"
            style="background-color:#0F9934;border-color:#0F9934;"
            @click="$eventHub.$emit('send-yagish-recruit');">規約に同意して応募する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSendedYagish == true" @click="closeDialog();">送信しました</el-button>
        </div>
        <br />
        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" v-if="isSended == false" type="primary"
            style="background-color:#999;border-color:#999;" @click="closeDialog();">同意しない</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" v-if="isSended == true" type="primary"
            style="background-color:#999;border-color:#999;" @click="closeDialog();">閉じる</el-button>
        </div>
      </div>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { emitRtDialogClosedWithoutSubmit } from '@/plugins/emitter'
export default {
  components: {
  },
  data: function () {
    return {
      isMypage: false,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      gradeYear: 0,
      permissionType: 1,
      isSended1: false,
      isSended2: false,
      isSended3: false,
      isSended4: false,
      isSendedAdtop: false,
      isSendedYagish: false,
      fullscreenLoading: false,
      clientId: 'realive_mail',
      username: '',
      baite_title: 'バイト',
      isAgree: false,
      inputEmail: '',
      foreignStudent: false,
      isRandom: true
    }
  },
  created: function () {
    console.error('realive created')
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      // console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
      if (key === 'format_rirekisho') {
        app.gradeYear = value.gradeYear
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed')
      }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openRealiveDialog: function (id, html, email, grade, isMypage = false) {
      this.isMypage = isMypage
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.inputEmail = email
      this.gradeYear = grade
      if (this.gradeYear == 24) {
        return
      }
      this.$modal.show('realive-dialog')
      this.clearLocalStorageConfirmVisible = false
      const app = this
      let isAdtop = false
      this.$iterateStorage(function (value, key, iterationNumber) {
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
        if (key === 'format_rirekisho') {
          app.foreignStudent = value.foreignStudent
        }
        if (app.foreignStudent) {
          app.permissionType = 4
        } else {
          if (app.gradeYear == 24) {
            app.permissionType = 1
          } else if (app.gradeYear == 23) {
            isAdtop = true
            console.error(isAdtop)
            app.permissionType = 2
          } else {
            app.permissionType = 2
          }
        }
        if (app.formatid == 'internship') {
          app.permissionType = 1
          isAdtop = false
        }
      }, function (err) {
        if (!err) {
          if (!isAdtop) {
            const formData = new FormData()
            formData.append('uuid', app.$firebase.user.uid)
            formData.append('format_id', app.formatid)
            formData.append('dialog_name', 'realive_dialog')
            formData.append('permission_type', app.permissionType)
            formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
            formData.append('version', '2')
            formData.append('is_mypage', this.isMypage ? 'true' : 'false')
            formData.append('site_flag', 'r')
            formData.append('app_flag', this.$site.appFlag)
            app.$axios.post(app.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
          } else {
            app.$eventHub.$emit('open-newgrade-dialog', id, html, email, grade)
            app.closeDialog()
          }
        }
      })
    },
    closeDialog: function () {
      this.$modal.hide('realive-dialog')
      this.clearLocalStorageConfirmVisible = false
      // this.$router.push('/mypage')
    },
    handleBeforeClose: function (event) {
      if (!this.isSended) {
        this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
        emitRtDialogClosedWithoutSubmit()
      }
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendrealiveConsult1: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      if (this.$deviceLib.isMobileDevice == 'SP') {
        window.open('https://job-tryout.com/2024/seminar/171', '_blank')
      } else {
        window.open('https://job-tryout.com/2024/seminar/171', '_blank')
      }
      this.sendrealiveCommon()
    },
    sendrealiveConsult2: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (this.$deviceLib.isMobileDevice == 'SP') {
        window.open('https://job-tryout.com/2024/seminar/172', '_blank')
      } else {
        window.open('https://job-tryout.com/2024/seminar/172', '_blank')
      }
      this.sendrealiveCommon()
    },
    sendrealiveConsult3: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (this.$deviceLib.isMobileDevice == 'SP') {
        window.open('https://job-tryout.com/2024/seminar/173', '_blank')
      } else {
        window.open('https://job-tryout.com/2024/seminar/173', '_blank')
      }
      this.sendrealiveCommon()
    },
    sendrealiveConsult4: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (this.$deviceLib.isMobileDevice == 'SP') {
        window.open('https://job-tryout.com/2024/seminar/174', '_blank')
      } else {
        window.open('https://job-tryout.com/2024/seminar/174', '_blank')
      }
      this.sendrealiveCommon()
    },
    sendrealiveCommon: async function () {
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      const app = this
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('dialog_name', 'realive_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.sendRealive, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSended = true
          app.$globalVar.eventTag()
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: '担当者からあなたのメールアドレスに連絡が届くことがあります！',
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendNewgradeAdtopConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      const app = this
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      if ((!this.$firebase.user.email && this.inputEmail) ||
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail)) {
        formData.append('inputemail', this.inputEmail)
      }
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('dialog_name', 'realive_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.newGradPdfMail, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: '担当者からあなたのメールアドレスに連絡が届くことがあります！',
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendYagishRecruit: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      const app = this
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      if ((!this.$firebase.user.email && this.inputEmail) ||
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail)) {
        formData.append('inputemail', this.inputEmail)
      }
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('dialog_name', 'realive_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.yagishRecruitPdfMail, formData, { timeout: 60000 })
        .then(function (response) {
          // app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: '担当者からあなたのメールアドレスに連絡が届くことがあります！',
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-newgrade-adtop-consult', this.sendNewgradeAdtopConsult)
    this.$eventHub.$on('send-realive-consult1', this.sendrealiveConsult1)
    this.$eventHub.$on('send-realive-consult2', this.sendrealiveConsult2)
    this.$eventHub.$on('send-realive-consult3', this.sendrealiveConsult3)
    this.$eventHub.$on('send-realive-consult4', this.sendrealiveConsult4)
    this.$eventHub.$on('open-realive-dialog', this.openRealiveDialog)
    this.$eventHub.$on('send-yagish-recruit', this.sendYagishRecruit)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-newgrade-adtop-consult', this.sendNewgradeAdtopConsult)
    this.$eventHub.$off('send-realive-consult1', this.sendrealiveConsult1)
    this.$eventHub.$off('send-realive-consult2', this.sendrealiveConsult2)
    this.$eventHub.$off('send-realive-consult3', this.sendrealiveConsult3)
    this.$eventHub.$off('send-realive-consult4', this.sendrealiveConsult4)
    this.$eventHub.$off('open-realive-dialog', this.openRealiveDialog)
    this.$eventHub.$off('send-yagish-recruit', this.sendYagishRecruit)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
